var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@cloudscape-design/components/icon";
export var ArrowUp = function () {
    return (_jsx("svg", __assign({ className: "custom_icon collapse", viewBox: "0 0 11 7", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0.687439 5.46484L1.57051 6.34791L5.49994 2.41897L9.42937 6.34791L10.3124 5.46484L5.49994 0.652344L0.687439 5.46484Z", fill: "currentColor" }) })));
};
export var ArrowDown = function () {
    return (_jsx("svg", __assign({ className: "custom_icon expand", viewBox: "0 0 11 7", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M10.3126 1.53516L9.42949 0.652089L5.50006 4.58103L1.57063 0.652088L0.687561 1.53516L5.50006 6.34766L10.3126 1.53516Z", fill: "currentColor" }) })));
};
export var ExpandCollapseIcon = function (_a) {
    var bottom = _a.bottom, collapsed = _a.collapsed;
    if (bottom) {
        return collapsed ? _jsx(ArrowUp, {}) : _jsx(ArrowDown, {});
    }
    else {
        return collapsed ? _jsx(ArrowDown, {}) : _jsx(ArrowUp, {});
    }
};
export var WindowsIcon = function () {
    return (_jsx(Icon, { svg: _jsxs("svg", __assign({ width: "19", height: "19", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "9.5", cy: "5.5", r: "0.5", fill: "currentColor" }), _jsx("circle", { cx: "11.5", cy: "5.5", r: "0.5", fill: "currentColor" }), _jsx("circle", { cx: "13.5", cy: "5.5", r: "0.5", fill: "currentColor" }), _jsx("path", { d: "M3.5 8H15", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("rect", { x: "3", y: "3", width: "13", height: "13", stroke: "currentColor", strokeWidth: "2" })] })) }));
};
